import { ComponentType } from '../types/components';
import { ActionType } from '../types/properties';
import { AlignValue, FlexSizeSpecValue, FontWeight, Layout, MediaContentMode } from '../types/styles';
const sample_1 = {
    version: 1,
    body: {
        items: [
            {
                type: ComponentType.Image,
                action: { type: ActionType.Web, data: 'https://docs.sendbird.com' },
                height: { type: 'fixed', value: 236 },
                viewStyle: {
                    padding: {
                        left: 4,
                        right: 4,
                        top: 4,
                        bottom: 4,
                    },
                },
                imageUrl: 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                imageStyle: { contentMode: MediaContentMode.AspectFill },
            },
            {
                type: ComponentType.Box,
                layout: Layout.Column,
                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                height: { type: 'fixed', value: 200 },
                items: [
                    {
                        type: ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        viewStyle: { backgroundColor: '#fa6464' },
                    },
                    {
                        type: ComponentType.Box,
                        layout: Layout.Column,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'flex', value: FlexSizeSpecValue.WrapContent },
                        viewStyle: { backgroundColor: '#ffaf5c' },
                        items: [
                            {
                                type: ComponentType.Text,
                                text: 'Message',
                                align: { horizontal: AlignValue.Center, vertical: AlignValue.Center },
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                height: { type: 'fixed', value: 50 },
                            },
                            {
                                type: ComponentType.Image,
                                action: { type: ActionType.Web, data: 'https://docs.sendbird.com' },
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                height: { type: 'fixed', value: 50 },
                                imageUrl: 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                                imageStyle: { contentMode: MediaContentMode.AspectFill },
                            },
                        ],
                    },
                    {
                        type: ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'fixed', value: 20 },
                        viewStyle: { backgroundColor: '#ffe450' },
                    },
                    {
                        type: ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        viewStyle: { backgroundColor: '#329a1b' },
                    },
                ],
            },
            {
                type: ComponentType.Box,
                viewStyle: { padding: { top: 12, bottom: 12, left: 12, right: 12 } },
                layout: Layout.Column,
                items: [
                    {
                        type: ComponentType.Box,
                        align: { horizontal: AlignValue.Left, vertical: AlignValue.Center },
                        layout: Layout.Row,
                        viewStyle: {
                            borderWidth: 1,
                            borderColor: '#72723f',
                        },
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        height: { type: 'fixed', value: 150 },
                        items: [
                            {
                                type: ComponentType.Text,
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                height: { type: 'fixed', value: 50 },
                                text: 'Sample1 text',
                                maxTextLines: 1,
                                align: { vertical: AlignValue.Center, horizontal: AlignValue.Left },
                                viewStyle: {
                                    backgroundColor: '#cc4400',
                                },
                                textStyle: {
                                    size: 16,
                                    color: '#f8f8f8',
                                    weight: FontWeight.Bold,
                                },
                            },
                            {
                                type: ComponentType.ImageButton,
                                action: { type: ActionType.UIKit, data: 'uikit://delete' },
                                width: { type: 'fixed', value: 20 },
                                height: { type: 'fixed', value: 20 },
                                imageUrl: 'https://file-ap-1.sendbird.com/5b5379aa73fd460da22ffaf9a61d0d7f.png',
                                imageStyle: { contentMode: MediaContentMode.AspectFit },
                            },
                        ],
                    },
                    {
                        type: ComponentType.Text,
                        viewStyle: { padding: { top: 6, bottom: 12, left: 0, right: 0 } },
                        text: 'Esse eu esse duis ipsum et dolor eu ut sit amet consectetur cillum velit officia. Ex adipisicing elit quis ea sit. Occaecat in eu aliqua nulla magna id ut excepteur minim.',
                        maxTextLines: 2,
                        textStyle: { size: 14, color: '#e10000' },
                        width: { type: 'fixed', value: 200 },
                        height: { type: 'fixed', value: 50 },
                    },
                    {
                        type: ComponentType.TextButton,
                        action: { type: ActionType.Web, data: 'https://www.daum.net' },
                        text: 'Button 3',
                        textStyle: { size: 14, color: '#742ddd', weight: FontWeight.Bold },
                    },
                ],
            },
        ],
    },
};
const sample_2 = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': ComponentType.Image,
                'action': { 'type': ActionType.Web, 'data': 'https://www.naver.com/' },
                'height': { 'type': 'fixed', 'value': 136 },
                'imageUrl': 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
            },
            {
                'type': ComponentType.Box,
                'viewStyle': { 'padding': { 'top': 12, 'bottom': 12, 'left': 12, 'right': 12 }, backgroundColor: '#cccccc' },
                'layout': Layout.Column,
                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                'items': [
                    {
                        'type': ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        'layout': Layout.Row,
                        'items': [
                            {
                                'type': ComponentType.TextButton,
                                'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                width: { type: 'fixed', value: 150 },
                                'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 0, 'right': 4 } },
                                'text': 'Button 2',
                                'textStyle': { 'size': 14, 'weight': FontWeight.Bold },
                            },
                            {
                                'type': ComponentType.TextButton,
                                'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                                'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 4, 'right': 0 } },
                                'text': 'Button 3',
                                'textStyle': { 'size': 14, 'weight': FontWeight.Bold },
                            },
                        ],
                    },
                    {
                        'type': ComponentType.Box,
                        width: { type: 'flex', value: FlexSizeSpecValue.FillParent },
                        'layout': Layout.Row,
                        'items': [
                            {
                                'type': ComponentType.Text,
                                'text': 'Sample2 text',
                                'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                                'maxTextLines': 1,
                                'textStyle': { 'size': 16, 'weight': FontWeight.Bold },
                            },
                            {
                                'type': ComponentType.ImageButton,
                                'action': { 'type': ActionType.UIKit, 'data': 'uikit://delete' },
                                'width': { 'type': 'fixed', 'value': 20 },
                                'height': { 'type': 'fixed', 'value': 20 },
                                'imageUrl': 'https://file-ap-1.sendbird.com/5b5379aa73fd460da22ffaf9a61d0d7f.png',
                                'imageStyle': { 'contentMode': MediaContentMode.AspectFit },
                            },
                        ],
                    },
                    {
                        'type': ComponentType.Text,
                        'viewStyle': { 'padding': { 'top': 6, 'bottom': 12, 'left': 0, 'right': 0 } },
                        'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                        'textStyle': { 'size': 14 },
                    },
                ],
            },
        ],
    },
};
const sample_3 = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': ComponentType.Box,
                'viewStyle': { 'backgroundColor': '#ffffff', 'borderWidth': 1, 'borderColor': '#eeeeee', 'radius': 16 },
                'layout': Layout.Column,
                'items': [
                    {
                        'type': ComponentType.Image,
                        'height': { 'type': 'fixed', 'value': 200 },
                        'imageUrl': 'https://img.freepik.com/free-vector/cartoon-happy-hours-background_52683-81243.jpg?w=2000&t=st=1666689198~exp=1666689798~hmac=23109d44ba03deee7aee069cbeebfcb48fa27f85e53c1cafc5d5d7345f1a2041',
                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
                    },
                    {
                        'type': ComponentType.Box,
                        'viewStyle': { 'padding': { 'top': 15, 'bottom': 15, 'left': 15, 'right': 15 } },
                        'layout': Layout.Column,
                        'items': [
                            {
                                'type': ComponentType.Text,
                                'text': "Don't miss these deals today",
                                'maxTextLines': 1,
                                'textStyle': { 'size': 20, 'color': '#e10000', 'weight': FontWeight.Bold },
                            },
                            {
                                'type': ComponentType.Text,
                                'viewStyle': { 'margin': { 'top': 5, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'text': 'Pay with Maya and get cashback!',
                                'maxTextLines': 1,
                                'textStyle': { 'size': 14, 'color': '#e10000' },
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Image,
                                        'width': { 'type': 'fixed', 'value': 50 },
                                        'height': { 'type': 'fixed', 'value': 50 },
                                        'viewStyle': {
                                            'backgroundColor': '#ffffff',
                                            'borderWidth': 1,
                                            'borderColor': '#eeeeee',
                                            'radius': 25,
                                        },
                                        'imageUrl': 'https://yt3.ggpht.com/ytc/AMLnZu8Kg89ymE7qt5bsS9vMqi9h2aHiN6m9ID-IgxR6-Q=s900-c-k-c0x00ffffff-no-rj',
                                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                        'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 15, 'right': 0 } },
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'Meralco',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 16, 'color': '#e10000', 'weight': FontWeight.Bold },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'viewStyle': { 'margin': { 'top': 3, 'bottom': 0, 'left': 0, 'right': 0 } },
                                                'text': '30% cashback, P300 min spend',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 12, 'color': '#610000', 'weight': FontWeight.Bold },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Image,
                                        'width': { 'type': 'fixed', 'value': 50 },
                                        'height': { 'type': 'fixed', 'value': 50 },
                                        'viewStyle': {
                                            'backgroundColor': '#ffffff',
                                            'borderWidth': 1,
                                            'borderColor': '#eeeeee',
                                            'radius': 25,
                                        },
                                        'imageUrl': 'https://1000logos.net/wp-content/uploads/2021/12/Globe-Telecom-logo.png',
                                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill, tintColor: '#a49a9a' },
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                        'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 15, 'right': 0 } },
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'Globe',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 16, 'color': '#e10000', 'weight': FontWeight.Bold },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'viewStyle': { 'margin': { 'top': 3, 'bottom': 0, 'left': 0, 'right': 0 } },
                                                'text': '30% cashback, P300 min spend',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 12, 'color': '#610000', 'weight': FontWeight.Bold },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Image,
                                        'width': { 'type': 'fixed', 'value': 50 },
                                        'height': { 'type': 'fixed', 'value': 50 },
                                        'viewStyle': {
                                            'backgroundColor': '#ffffff',
                                            'borderWidth': 1,
                                            'borderColor': '#eeeeee',
                                            'radius': 25,
                                        },
                                        'imageUrl': 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Cignal.svg/640px-Cignal.svg.png',
                                        'imageStyle': { 'contentMode': MediaContentMode.AspectFill },
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                        'viewStyle': { 'margin': { 'top': 0, 'bottom': 0, 'left': 15, 'right': 0 } },
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'Cignal',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 16, 'color': '#e10000', 'weight': FontWeight.Bold },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'viewStyle': { 'margin': { 'top': 3, 'bottom': 0, 'left': 0, 'right': 0 } },
                                                'text': '30% cashback, P300 min spend',
                                                'maxTextLines': 1,
                                                'textStyle': { 'size': 12, 'color': '#610000', 'weight': FontWeight.Bold },
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'align': { 'horizontal': AlignValue.Left, 'vertical': AlignValue.Center },
                                'viewStyle': { 'margin': { 'top': 10, 'bottom': 0, 'left': 0, 'right': 0 } },
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.TextButton,
                                        'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                        'viewStyle': {
                                            'backgroundColor': '#e0e0e0',
                                            'radius': 16,
                                            'margin': { 'top': 0, 'bottom': 0, 'left': 0, 'right': 4 },
                                            'padding': { 'top': 12, 'bottom': 12, 'left': 12, 'right': 12 },
                                        },
                                        'text': 'Learn more',
                                        'textStyle': { 'size': 15, 'color': '#e10000', 'weight': FontWeight.Bold },
                                    },
                                    {
                                        'type': ComponentType.TextButton,
                                        'action': { 'type': ActionType.Web, 'data': 'https://www.daum.net' },
                                        'viewStyle': {
                                            'backgroundColor': '#e10000',
                                            'radius': 16,
                                            'margin': { 'top': 0, 'bottom': 0, 'left': 4, 'right': 0 },
                                            'padding': { 'top': 12, 'bottom': 12, 'left': 12, 'right': 12 },
                                        },
                                        'text': 'Pay now',
                                        'textStyle': { 'size': 15, 'color': '#ffffff', 'weight': FontWeight.Bold },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
const sample_4 = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': ComponentType.Box,
                'layout': Layout.Column,
                'items': [
                    {
                        'type': ComponentType.Image,
                        'imageUrl': 'https://static.sendbird.com/sample/profiles/profile_40_512px.png',
                        'metaData': {
                            'pixelWidth': 512,
                            'pixelHeight': 512,
                        },
                        'imageStyle': {
                            'tintColor': '#44ff1188',
                        },
                        viewStyle: {
                            'padding': {
                                'top': 12,
                                'right': 12,
                                'bottom': 12,
                                'left': 12,
                            },
                        },
                    },
                    {
                        'type': ComponentType.Box,
                        'viewStyle': {
                            'padding': {
                                'top': 12,
                                'right': 12,
                                'bottom': 12,
                                'left': 12,
                            },
                        },
                        'layout': Layout.Column,
                        'items': [
                            {
                                'type': ComponentType.Box,
                                'layout': Layout.Row,
                                'items': [
                                    {
                                        'type': ComponentType.Box,
                                        'layout': Layout.Column,
                                        'items': [
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'hi',
                                                'maxTextLines': 3,
                                                'viewStyle': {
                                                    'padding': {
                                                        'top': 0,
                                                        'bottom': 6,
                                                        'left': 0,
                                                        'right': 0,
                                                    },
                                                },
                                                'textStyle': {
                                                    'size': 16,
                                                    'weight': FontWeight.Bold,
                                                },
                                            },
                                            {
                                                'type': ComponentType.Text,
                                                'text': 'bye',
                                                'maxTextLines': 10,
                                                'textStyle': {
                                                    'size': 14,
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        'type': ComponentType.ImageButton,
                                        'action': {
                                            'type': ActionType.UIKit,
                                            'data': 'sendbirduikit://delete',
                                        },
                                        'width': {
                                            'type': 'fixed',
                                            'value': 20,
                                        },
                                        'height': {
                                            'type': 'fixed',
                                            'value': 20,
                                        },
                                        'metaData': {
                                            'pixelWidth': 60,
                                            'pixelHeight': 60,
                                        },
                                        'imageUrl': 'https://dxstmhyqfqr1o.cloudfront.net/sendbird-message-builder/icon-more.png',
                                        'imageStyle': {
                                            'tintColor': '#ff8d5a',
                                        },
                                    },
                                ],
                            },
                            {
                                'type': ComponentType.Box,
                                'layout': Layout.Column,
                                'items': [
                                    {
                                        'type': ComponentType.Box,
                                        'viewStyle': {
                                            'margin': {
                                                'top': 16,
                                                'bottom': 0,
                                                'left': 0,
                                                'right': 0,
                                            },
                                        },
                                        'align': {
                                            'horizontal': AlignValue.Left,
                                            'vertical': AlignValue.Center,
                                        },
                                        'layout': Layout.Row,
                                        'items': [
                                            {
                                                'type': ComponentType.Image,
                                                'imageUrl': 'https://ca.slack-edge.com/T0ADCTNEL-ULE240VNV-83fd5776e78e-512',
                                                'width': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'height': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'metaData': {
                                                    'pixelWidth': 512,
                                                    'pixelHeight': 512,
                                                },
                                                'viewStyle': {
                                                    'backgroundColor': '#BDBDBD',
                                                    'radius': 20,
                                                },
                                                'imageStyle': {
                                                    'contentMode': MediaContentMode.AspectFill,
                                                },
                                            },
                                            {
                                                'type': ComponentType.Box,
                                                'viewStyle': {
                                                    'margin': {
                                                        'top': 0,
                                                        'bottom': 0,
                                                        'left': 12,
                                                        'right': 0,
                                                    },
                                                },
                                                'layout': Layout.Column,
                                                'items': [
                                                    {
                                                        'type': ComponentType.Text,
                                                        'text': 'Chongbu',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 16,
                                                            'weight': FontWeight.Bold,
                                                        },
                                                    },
                                                    {
                                                        'type': ComponentType.Text,
                                                        'viewStyle': {
                                                            'margin': {
                                                                'top': 4,
                                                                'bottom': 0,
                                                                'left': 0,
                                                                'right': 0,
                                                            },
                                                        },
                                                        'text': ' ',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 14,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        'type': ComponentType.Box,
                                        'viewStyle': {
                                            'margin': {
                                                'top': 16,
                                                'bottom': 0,
                                                'left': 0,
                                                'right': 0,
                                            },
                                        },
                                        'align': {
                                            'horizontal': AlignValue.Left,
                                            'vertical': AlignValue.Center,
                                        },
                                        'layout': Layout.Row,
                                        'items': [
                                            {
                                                'type': ComponentType.Image,
                                                'imageUrl': 'https://ca.slack-edge.com/T0ADCTNEL-U02LA25KY8J-d41a3e8c7554-512',
                                                'width': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'height': {
                                                    'type': 'fixed',
                                                    'value': 40,
                                                },
                                                'metaData': {
                                                    'pixelWidth': 512,
                                                    'pixelHeight': 512,
                                                },
                                                'viewStyle': {
                                                    'backgroundColor': '#BDBDBD',
                                                    'radius': 20,
                                                },
                                                'imageStyle': {
                                                    'contentMode': MediaContentMode.AspectFill,
                                                },
                                            },
                                            {
                                                'type': ComponentType.Box,
                                                'viewStyle': {
                                                    'margin': {
                                                        'top': 0,
                                                        'bottom': 0,
                                                        'left': 12,
                                                        'right': 0,
                                                    },
                                                },
                                                'layout': Layout.Column,
                                                'items': [
                                                    {
                                                        'type': ComponentType.Text,
                                                        'text': 'Amanda',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 16,
                                                            'weight': FontWeight.Bold,
                                                        },
                                                    },
                                                    {
                                                        'type': ComponentType.Text,
                                                        'viewStyle': {
                                                            'margin': {
                                                                'top': 4,
                                                                'bottom': 0,
                                                                'left': 0,
                                                                'right': 0,
                                                            },
                                                        },
                                                        'text': 'This is title message',
                                                        'maxTextLines': 1,
                                                        'textStyle': {
                                                            'size': 14,
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
const sample_5 = {
    'version': '1',
    'body': {
        'items': [
            {
                'type': 'box',
                'layout': 'column',
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'items': [
                            {
                                'type': 'image',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'fixed', 'value': '250' },
                                'imageUrl': 'https://dxstmhyqfqr1o.cloudfront.net/notifications/notifications-default-image.png',
                                'imageStyle': { 'contentMode': 'aspectFill' },
                            },
                            {
                                'type': 'box',
                                'layout': 'column',
                                'viewStyle': {
                                    'radius': '8',
                                    'padding': {
                                        'top': '12',
                                        'bottom': '12',
                                        'left': '12',
                                        'right': '12',
                                    },
                                },
                                'items': [
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'margin': {
                                                'top': '8',
                                                'right': '0',
                                                'bottom': '0',
                                                'left': '0',
                                            },
                                        },
                                        'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
                                        'textStyle': {
                                            'color': '#ff8888',
                                            'size': '14',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'height': { 'type': 'fixed', 'value': '300' },
                                        'width': { 'type': 'flex', 'value': '0' },
                                    },
                                    {
                                        'type': 'box',
                                        'layout': 'column',
                                        'viewStyle': {
                                            'margin': {
                                                'top': '12',
                                                'right': '0',
                                                'bottom': '0',
                                                'left': '0',
                                            },
                                        },
                                        'items': [
                                            {
                                                'type': 'box',
                                                'layout': 'row',
                                                'items': [
                                                    {
                                                        'type': 'imageButton',
                                                        'viewStyle': { 'radius': '100' },
                                                        'width': { 'type': 'fixed', 'value': 40 },
                                                        'height': { 'type': 'fixed', 'value': 40 },
                                                        'imageUrl': 'https://dxstmhyqfqr1o.cloudfront.net/notifications/default-notification-channel-cover.png',
                                                        'imageStyle': { 'contentMode': 'aspectFill' },
                                                        'metaData': {
                                                            'pixelWidth': '240',
                                                            'pixelHeight': '240',
                                                        },
                                                    },
                                                    {
                                                        'type': 'box',
                                                        'layout': 'column',
                                                        'viewStyle': {
                                                            'margin': {
                                                                'left': '12',
                                                                'top': '0',
                                                                'right': '0',
                                                                'bottom': '0',
                                                            },
                                                        },
                                                        'items': [
                                                            {
                                                                'type': 'text',
                                                                'text': 'List title',
                                                                'textStyle': {
                                                                    'color': '{SBCOLOR_nppqb}',
                                                                    'size': '16',
                                                                    'weight': 'bold',
                                                                },
                                                                'maxTextLines': '5',
                                                            },
                                                            {
                                                                'type': 'text',
                                                                'text': 'List body',
                                                                'textStyle': {
                                                                    'color': '{SBCOLOR_ls5oj}',
                                                                    'size': '14',
                                                                    'weight': 'normal',
                                                                },
                                                                'maxTextLines': '5',
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        'type': 'box',
                                        'layout': 'row',
                                        'viewStyle': {
                                            'margin': {
                                                'top': '12',
                                                'right': '0',
                                                'bottom': '0',
                                                'left': '0',
                                            },
                                        },
                                        'items': [
                                            {
                                                'type': 'textButton',
                                                'viewStyle': {
                                                    'backgroundColor': '{SBCOLOR_vmp47}',
                                                    'padding': {
                                                        'top': '10',
                                                        'bottom': '10',
                                                        'left': '20',
                                                        'right': '20',
                                                    },
                                                },
                                                'text': 'Button 1',
                                                'textStyle': {
                                                    'color': '{SBCOLOR_0r9vw}',
                                                    'size': '14',
                                                    'weight': 'bold',
                                                },
                                                'maxTextLines': '5',
                                            },
                                            {
                                                'type': 'textButton',
                                                'viewStyle': {
                                                    'backgroundColor': '{SBCOLOR_vmp47}',
                                                    'padding': {
                                                        'top': '10',
                                                        'bottom': '10',
                                                        'left': '20',
                                                        'right': '20',
                                                    },
                                                    'margin': {
                                                        'left': '8',
                                                        'right': '0',
                                                        'top': '0',
                                                        'bottom': '0',
                                                    },
                                                },
                                                'text': 'Button 2',
                                                'textStyle': {
                                                    'color': '{SBCOLOR_0r9vw}',
                                                    'size': '14',
                                                    'weight': 'bold',
                                                },
                                                'maxTextLines': '5',
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
const sample_6 = {
    'version': '1',
    'body': {
        'items': [
            {
                'type': 'box',
                'layout': 'column',
                height: { type: 'fixed', value: 600 },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'viewStyle': { 'radius': '8', 'padding': { 'top': '12', 'bottom': '12', 'left': '12', 'right': '12' } },
                        'items': [
                            {
                                'type': 'text',
                                'text': 'Title text',
                                'textStyle': { 'color': '#E0000000', 'size': '16', 'weight': 'bold' },
                                'maxTextLines': '5',
                                'viewStyle': {},
                                'action': { 'data': 'www.naver.com' },
                            },
                            {
                                'type': 'text',
                                'viewStyle': { 'margin': { 'top': '8', 'right': '0', 'bottom': '0', 'left': '0' } },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': { 'color': '#E0000000', 'size': '14', 'weight': 'normal' },
                                'maxTextLines': '5',
                                'action': { 'data': 'https://www.naver.com' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'viewStyle': { 'margin': { 'top': '12', 'right': '0', 'bottom': '0', 'left': '0' } },
                                'items': [
                                    {
                                        'type': 'textButton',
                                        'viewStyle': {
                                            'backgroundColor': '#E0E0E0',
                                            'padding': { 'top': '10', 'bottom': '10', 'left': '20', 'right': '20' },
                                        },
                                        'text': 'Button 1',
                                        'textStyle': { 'color': '#742DDD', 'size': '14', 'weight': 'bold' },
                                        'maxTextLines': '5',
                                        'action': { 'data': 'www.naver.com' },
                                    },
                                    {
                                        'type': 'textButton',
                                        'viewStyle': {
                                            'backgroundColor': '#E0E0E0',
                                            'padding': { 'top': '10', 'bottom': '10', 'left': '20', 'right': '20' },
                                            'margin': { 'left': '8', 'right': '0', 'top': '0', 'bottom': '0' },
                                        },
                                        'text': 'Button 2',
                                        'textStyle': { 'color': '#742DDD', 'size': '14', 'weight': 'bold' },
                                        'maxTextLines': '5',
                                        'action': { 'data': 'https://www.naver.com' },
                                    },
                                ],
                            },
                        ],
                        'action': { 'data': 'https://www.naver.com' },
                    },
                    {
                        'type': 'image',
                        'viewStyle': {},
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'imageStyle': { 'contentMode': 'aspectFill' },
                        'imageUrl': 'https://file-preprod.sendbird.com/d03c08bb3f9041a88c1207b6bbf15ab8.png',
                        'metaData': { 'pixelWidth': '1062', 'pixelHeight': '1070' },
                    },
                    {
                        'type': 'textButton',
                        'viewStyle': {
                            'backgroundColor': '#E0E0E0',
                            'padding': { 'top': '10', 'bottom': '10', 'left': '20', 'right': '20' },
                        },
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'text': 'Button',
                        'textStyle': { 'color': '#742DDD', 'size': '16', 'weight': 'normal' },
                        'maxTextLines': '5',
                        'action': { 'data': 'www.naver.com' },
                    },
                    {
                        'type': 'imageButton',
                        'viewStyle': {},
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'imageUrl': 'https://file-preprod.sendbird.com/38fdf5c1056f42b89a44b38155cc4b49.jpg',
                        'imageStyle': { 'contentMode': 'aspectFill' },
                        'metaData': { 'pixelWidth': '1080', 'pixelHeight': '2640' },
                        'action': { 'data': 'www.naver.com' },
                    },
                ],
                'viewStyle': {},
            },
        ],
    },
};
const sample_for_inset_border = {
    'version': '1',
    'body': {
        'items': [
            {
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': '0',
                },
                'height': {
                    'type': 'flex',
                    'value': '1',
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'borderWidth': '10',
                            'borderColor': '#0e0101ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': '0',
                        },
                        'height': {
                            'type': 'flex',
                            'value': '1',
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f9dadaff',
                                    'borderColor': '#fb7373ff',
                                    'borderWidth': '5',
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': '14',
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': '5',
                                'width': {
                                    'type': 'flex',
                                    'value': '0',
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': '1',
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#bbd1f5ff',
                                    'borderColor': '#0497f9ff',
                                    'borderWidth': '10',
                                    'padding': {
                                        'top': '16',
                                        'bottom': '16',
                                        'left': '16',
                                        'right': '16',
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': '14',
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': '5',
                                'width': {
                                    'type': 'flex',
                                    'value': '0',
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': '1',
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'borderWidth': '10',
                            'borderColor': '#298e04ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': '0',
                        },
                        'height': {
                            'type': 'flex',
                            'value': '1',
                        },
                        'items': [
                            {
                                'type': 'textButton',
                                'viewStyle': {
                                    'backgroundColor': '#a6b7ebff',
                                    'borderColor': '#0f0ff9ff',
                                    'borderWidth': '5',
                                    'radius': '6',
                                },
                                'text': 'Button',
                                'textStyle': {
                                    'size': '14',
                                    'color': '#ffffffff',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '1',
                                'width': {
                                    'type': 'flex',
                                    'value': '0',
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': '1',
                                },
                            },
                            {
                                'type': 'imageButton',
                                'viewStyle': {
                                    'backgroundColor': '#000000ff',
                                    'borderColor': '#ff00b9ff',
                                    'borderWidth': '5',
                                },
                                'imageUrl': 'https://ddtyj01cn62am.cloudfront.net/notifications/img-component-default-imgbutton.png',
                                'imageStyle': {
                                    'contentMode': 'aspectFill',
                                    'tintColor': '#ffffffff',
                                },
                                'metaData': {
                                    'pixelWidth': '72',
                                    'pixelHeight': '72',
                                },
                                'width': {
                                    'type': 'fixed',
                                    'value': '36',
                                },
                                'height': {
                                    'type': 'fixed',
                                    'value': '36',
                                },
                            },
                            {
                                'type': 'image',
                                'viewStyle': {
                                    'backgroundColor': '#828282ff',
                                    'borderColor': '#fe0000ff',
                                    'borderWidth': '10',
                                    'radius': '20',
                                },
                                'imageUrl': 'https://file-preprod.sendbird.com/99c1ceafd8304076a7123caeea9aeb9a.png',
                                'imageStyle': {
                                    'contentMode': 'aspectFill',
                                },
                                'width': {
                                    'type': 'fixed',
                                    'value': '50',
                                },
                                'height': {
                                    'type': 'fixed',
                                    'value': '50',
                                },
                                'metaData': {
                                    'pixelHeight': '225',
                                    'pixelWidth': '225',
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
const sample_clipped_text__large_padding = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'text',
                'height': {
                    'type': 'fixed',
                    'value': 120,
                },
                'width': {
                    'type': 'fixed',
                    'value': 150,
                },
                'maxTextLines': 2,
                'viewStyle': {
                    'padding': {
                        'left': 50,
                        'right': 50,
                        'top': 50,
                        'bottom': 50,
                    },
                    borderWidth: 1,
                    borderColor: '#72723f',
                },
                'text': 'longtext long long longtext',
            },
        ],
    },
};
const sample_for_priority_by_size_spec = {
    'version': '1',
    'body': {
        'items': [
            {
                'type': 'box',
                'layout': 'column',
                'width': { 'type': 'flex', 'value': '0' },
                'height': { 'type': 'flex', 'value': '1' },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Fixed(short) / Wrap / Fill',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'text': 'FixedFixedFixedFixedFixedFixedFixedFixed',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'fixed', 'value': '30' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'text',
                                        'text': 'WrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrap',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#050505',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'text',
                                        'text': 'FillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFill',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#0c0c0c',
                                            'borderWidth': '1',
                                        },
                                    },
                                ],
                                'viewStyle': { 'borderColor': '#0a0a0a' },
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Fixed / Wrap(short) / Wrap(long)',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '2',
                                                'bottom': '2',
                                                'left': '2',
                                                'right': '2',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'FixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixed',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'fixed', 'value': '100' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                    {
                                        'type': 'box',
                                        'layout': 'row',
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'items': [
                                            {
                                                'type': 'text',
                                                'text': 'WrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrapWrap',
                                                'textStyle': {
                                                    'size': '14',
                                                    'color': '#000000',
                                                    'weight': 'normal',
                                                },
                                                'maxTextLines': '5',
                                                'width': { 'type': 'flex', 'value': '1' },
                                                'height': { 'type': 'flex', 'value': '1' },
                                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                            },
                                            {
                                                'type': 'text',
                                                'text': 'FixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixedFixed',
                                                'textStyle': {
                                                    'size': '14',
                                                    'color': '#000000',
                                                    'weight': 'normal',
                                                },
                                                'maxTextLines': '5',
                                                'width': { 'type': 'fixed', 'value': '100' },
                                                'height': { 'type': 'flex', 'value': '1' },
                                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Wrap / Fixed / Fill / Fill',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'text': 'wrap',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'box',
                                        'layout': 'row',
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'items': [
                                            {
                                                'type': 'text',
                                                'text': 'FillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFill',
                                                'textStyle': {
                                                    'size': '14',
                                                    'color': '#000000',
                                                    'weight': 'normal',
                                                },
                                                'maxTextLines': '5',
                                                'width': { 'type': 'flex', 'value': '0' },
                                                'height': { 'type': 'flex', 'value': '1' },
                                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                            },
                                            {
                                                'type': 'text',
                                                'text': 'WrapWrapWrapWrapWrapWrapWrapWrapWrapWrap',
                                                'textStyle': {
                                                    'size': '14',
                                                    'color': '#000000',
                                                    'weight': 'normal',
                                                },
                                                'maxTextLines': '5',
                                                'width': { 'type': 'flex', 'value': '1' },
                                                'height': { 'type': 'flex', 'value': '1' },
                                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Fill / Wrap(short) / Fixed',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'text': 'FillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFill',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'text',
                                        'text': 'Wrap',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'text',
                                        'text': 'Fixed',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'fixed', 'value': '100' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Fill Fill Fixed',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'text': 'FillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFill',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'text',
                                        'text': 'FillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFillFill',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                    {
                                        'type': 'text',
                                        'text': 'Fixed Fixed Fixed Fixed Fixed Fixed Fixed ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'fixed', 'value': '100' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                        'viewStyle': {
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Wrap(short) / Fill',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'appId-appId',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'text content text content text content text content text content text content ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Fill / Wrap(short)',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'text content text content text content text content text content text content ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'appId-appId',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Wrap(long) / Fill',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                        'viewStyle': {
                            'margin': {
                                'top': '0',
                                'bottom': '100',
                                'left': '0',
                                'right': '0',
                            },
                        },
                        'width': { 'type': 'flex', 'value': '0' },
                        'height': { 'type': 'flex', 'value': '1' },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'padding': {
                                        'top': '8',
                                        'bottom': '8',
                                        'left': '0',
                                        'right': '8',
                                    },
                                },
                                'text': 'Fill / Wrap(long)',
                                'textStyle': {
                                    'size': '20',
                                    'color': '#000000',
                                    'weight': 'bold',
                                },
                                'maxTextLines': '5',
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                            },
                            {
                                'type': 'box',
                                'layout': 'row',
                                'align': { 'horizontal': 'left', 'vertical': 'top' },
                                'width': { 'type': 'flex', 'value': '0' },
                                'height': { 'type': 'flex', 'value': '1' },
                                'items': [
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '0' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'padding': {
                                                'top': '5',
                                                'bottom': '5',
                                                'left': '5',
                                                'right': '5',
                                            },
                                            'borderColor': '#000000',
                                            'borderWidth': '1',
                                        },
                                        'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap ',
                                        'textStyle': {
                                            'size': '14',
                                            'color': '#000000',
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': '5',
                                        'width': { 'type': 'flex', 'value': '1' },
                                        'height': { 'type': 'flex', 'value': '1' },
                                        'align': { 'horizontal': 'left', 'vertical': 'top' },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
const horizontal_wrap_wrap = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#ffa0a0ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap Wrap ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '7ddcc4dc-465d-416f-adfa-fcb22262defe',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0ffacff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'ddc05097-0130-41b9-b32b-ea4d19fe1b17',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_wrap_wrap_wrap = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#ffa0a0ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '7ddcc4dc-465d-416f-adfa-fcb22262defe',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0ffacff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap2 Wrap2',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'ddc05097-0130-41b9-b32b-ea4d19fe1b17',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0a1ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap3 Wrap3 Wrap3 Wrap3 Wrap3 Wrap3 Wrap3 Wrap3 Wrap3 Wrap3 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '8d7ba180-f065-4037-beb1-dd3797729bf2',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#adffa0ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '7ddcc4dc-465d-416f-adfa-fcb22262defe',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_fill_wrap = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#b1f5a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'eccfb704-69bd-4c41-9730-befcab670e9d',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_fill_wrap = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#b1f5a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'eccfb704-69bd-4c41-9730-befcab670e9d',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#daa0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap2',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '69a40de4-1aa1-4028-ba85-030517c9faf3',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_fill_wrap_long = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#b1f5a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'eccfb704-69bd-4c41-9730-befcab670e9d',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#daa0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap2 Wrap2 Wrap2 Wrap2 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '69a40de4-1aa1-4028-ba85-030517c9faf3',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_fill_wrap_longer = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#b1f5a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'eccfb704-69bd-4c41-9730-befcab670e9d',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#daa0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '69a40de4-1aa1-4028-ba85-030517c9faf3',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_fill_wrap_super_long = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#b1f5a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 Fill1 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'eccfb704-69bd-4c41-9730-befcab670e9d',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#daa0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 Wrap2 ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '69a40de4-1aa1-4028-ba85-030517c9faf3',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_remain_padding = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_no_padding = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'viewStyle': {
                            'backgroundColor': '#000000ff',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#f5a3a3ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill Fill ',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'b9f8e599-6529-4736-b264-cb9811f44eeb',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a0c0ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                            },
                        ],
                        'elementId': 'ac8227f4-d3c0-4f8c-ac95-d9756d988e10',
                    },
                ],
            },
        ],
    },
};
const vertical_fill_wrap_wrap_remain_padding = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'fixed',
                            'value': 200,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#ff9191ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'ac074f97-a136-43c0-a7c2-9be937730c39',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#91ffa6ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'fcae6d34-7526-45b4-a4c7-1111814e62e1',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a891ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '00162fc8-22dc-46dc-872b-ba9590474f98',
                            },
                        ],
                        'elementId': '0e42079b-b373-496f-862b-8799ad34c599',
                    },
                ],
            },
        ],
    },
};
const vertical_fill_wrap_wrap_no_padding = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'fixed',
                            'value': 170,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#ff9191ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'ac074f97-a136-43c0-a7c2-9be937730c39',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#91ffa6ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'fcae6d34-7526-45b4-a4c7-1111814e62e1',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a891ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '00162fc8-22dc-46dc-872b-ba9590474f98',
                            },
                        ],
                        'elementId': '0e42079b-b373-496f-862b-8799ad34c599',
                    },
                ],
            },
        ],
    },
};
const horizontal_fill_wrap_wrap_long_content = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'items': [
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#ff9191ff',
                                    'radius': 1,
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'ac074f97-a136-43c0-a7c2-9be937730c39',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#91ffa6ff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': 'fcae6d34-7526-45b4-a4c7-1111814e62e1',
                            },
                            {
                                'type': 'text',
                                'viewStyle': {
                                    'backgroundColor': '#a891ffff',
                                    'padding': {
                                        'top': 16,
                                        'bottom': 16,
                                        'left': 16,
                                        'right': 16,
                                    },
                                },
                                'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aui',
                                'textStyle': {
                                    'size': 14,
                                    'color': '#222121e0',
                                    'weight': 'normal',
                                },
                                'maxTextLines': 5,
                                'width': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'align': {
                                    'horizontal': 'left',
                                    'vertical': 'top',
                                },
                                'elementId': '00162fc8-22dc-46dc-872b-ba9590474f98',
                            },
                        ],
                        'elementId': '0e42079b-b373-496f-862b-8799ad34c599',
                    },
                ],
            },
        ],
    },
};
const dashboard_preset_list = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': 0,
                },
                'height': {
                    'type': 'flex',
                    'value': 1,
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'column',
                        'items': [
                            {
                                'type': 'image',
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'imageUrl': 'https://ddtyj01cn62am.cloudfront.net/notifications/img-template-preset-default-image.png',
                                'imageStyle': {
                                    'contentMode': 'aspectFill',
                                },
                                'metaData': {
                                    'pixelWidth': 686,
                                    'pixelHeight': 320,
                                },
                                'elementId': '0f3d6ba4-715a-44d2-b776-5bdd1aed8bc5',
                            },
                            {
                                'type': 'box',
                                'layout': 'column',
                                'viewStyle': {
                                    'radius': 8,
                                    'padding': {
                                        'top': 12,
                                        'bottom': 12,
                                        'left': 12,
                                        'right': 12,
                                    },
                                },
                                'items': [
                                    {
                                        'type': 'text',
                                        'text': 'Title text',
                                        'textStyle': {
                                            'color': '#222121e0',
                                            'size': 16,
                                            'weight': 'bold',
                                        },
                                        'maxTextLines': 5,
                                        'height': {
                                            'type': 'flex',
                                            'value': 1,
                                        },
                                        'width': {
                                            'type': 'flex',
                                            'value': 0,
                                        },
                                        'elementId': '010811be-7c65-4aa8-8f8e-62c8398562b0',
                                    },
                                    {
                                        'type': 'text',
                                        'viewStyle': {
                                            'margin': {
                                                'top': 8,
                                                'right': 0,
                                                'bottom': 0,
                                                'left': 0,
                                            },
                                        },
                                        'text': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
                                        'textStyle': {
                                            'color': '#222121e0',
                                            'size': 14,
                                            'weight': 'normal',
                                        },
                                        'maxTextLines': 5,
                                        'height': {
                                            'type': 'flex',
                                            'value': 1,
                                        },
                                        'width': {
                                            'type': 'flex',
                                            'value': 0,
                                        },
                                        'elementId': '00aca18f-3cdf-404d-9e01-9a99f59fb8ae',
                                    },
                                    {
                                        'type': 'box',
                                        'layout': 'column',
                                        'viewStyle': {
                                            'margin': {
                                                'top': 12,
                                                'right': 0,
                                                'bottom': 0,
                                                'left': 0,
                                            },
                                            'padding': {
                                                'top': 4,
                                                'right': 0,
                                                'bottom': 4,
                                                'left': 0,
                                            },
                                        },
                                        'items': [
                                            {
                                                'type': 'box',
                                                'layout': 'row',
                                                'items': [
                                                    {
                                                        'type': 'imageButton',
                                                        'viewStyle': {
                                                            'radius': 100,
                                                            'backgroundColor': '#5a73baff',
                                                        },
                                                        'width': {
                                                            'type': 'fixed',
                                                            'value': 40,
                                                        },
                                                        'height': {
                                                            'type': 'fixed',
                                                            'value': 40,
                                                        },
                                                        'imageUrl': 'https://ddtyj01cn62am.cloudfront.net/notifications/default-notification-channel-cover.png',
                                                        'imageStyle': {
                                                            'contentMode': 'aspectFill',
                                                            'tintColor': '#ffffffff',
                                                        },
                                                        'elementId': '35a315e9-1f61-4a72-b7c9-ce34a0543343',
                                                    },
                                                    {
                                                        'type': 'box',
                                                        'layout': 'column',
                                                        'viewStyle': {
                                                            'margin': {
                                                                'left': 12,
                                                                'top': 0,
                                                                'right': 0,
                                                                'bottom': 0,
                                                            },
                                                        },
                                                        'items': [
                                                            {
                                                                'type': 'text',
                                                                'text': 'List title',
                                                                'textStyle': {
                                                                    'color': '#222121e0',
                                                                    'size': 16,
                                                                    'weight': 'bold',
                                                                },
                                                                'maxTextLines': 5,
                                                                'height': {
                                                                    'type': 'flex',
                                                                    'value': 1,
                                                                },
                                                                'width': {
                                                                    'type': 'flex',
                                                                    'value': 0,
                                                                },
                                                                'elementId': 'ef3c83b2-9149-46c1-a22d-beb878cf937a',
                                                            },
                                                            {
                                                                'type': 'text',
                                                                'text': 'List body',
                                                                'textStyle': {
                                                                    'color': '#222121e0',
                                                                    'size': 14,
                                                                    'weight': 'normal',
                                                                },
                                                                'maxTextLines': 5,
                                                                'height': {
                                                                    'type': 'flex',
                                                                    'value': 1,
                                                                },
                                                                'width': {
                                                                    'type': 'flex',
                                                                    'value': 0,
                                                                },
                                                                'elementId': 'a92ae89d-0726-46b5-b575-2db578b3d954',
                                                            },
                                                        ],
                                                        'height': {
                                                            'type': 'flex',
                                                            'value': 1,
                                                        },
                                                        'width': {
                                                            'type': 'flex',
                                                            'value': 0,
                                                        },
                                                        'elementId': 'ffb50576-f050-4a36-b64f-64864bb04734',
                                                    },
                                                ],
                                                'height': {
                                                    'type': 'flex',
                                                    'value': 1,
                                                },
                                                'width': {
                                                    'type': 'flex',
                                                    'value': 0,
                                                },
                                                'elementId': 'a9d30083-5b00-4ec6-bf2b-0b03c03b1632',
                                            },
                                            {
                                                'type': 'box',
                                                'layout': 'row',
                                                'viewStyle': {
                                                    'margin': {
                                                        'top': 16,
                                                        'right': 0,
                                                        'bottom': 0,
                                                        'left': 0,
                                                    },
                                                },
                                                'items': [
                                                    {
                                                        'type': 'imageButton',
                                                        'viewStyle': {
                                                            'radius': 100,
                                                            'backgroundColor': '#5a73baff',
                                                        },
                                                        'width': {
                                                            'type': 'fixed',
                                                            'value': 40,
                                                        },
                                                        'height': {
                                                            'type': 'fixed',
                                                            'value': 40,
                                                        },
                                                        'imageUrl': 'https://ddtyj01cn62am.cloudfront.net/notifications/default-notification-channel-cover.png',
                                                        'imageStyle': {
                                                            'contentMode': 'aspectFill',
                                                            'tintColor': '#ffffffff',
                                                        },
                                                        'elementId': '61fefa7c-0a03-4c92-9b26-2f7620982e46',
                                                    },
                                                    {
                                                        'type': 'box',
                                                        'layout': 'column',
                                                        'viewStyle': {
                                                            'margin': {
                                                                'left': 12,
                                                                'top': 0,
                                                                'right': 0,
                                                                'bottom': 0,
                                                            },
                                                        },
                                                        'items': [
                                                            {
                                                                'type': 'text',
                                                                'text': 'List title',
                                                                'textStyle': {
                                                                    'color': '#222121e0',
                                                                    'size': 16,
                                                                    'weight': 'bold',
                                                                },
                                                                'maxTextLines': 5,
                                                                'height': {
                                                                    'type': 'flex',
                                                                    'value': 1,
                                                                },
                                                                'width': {
                                                                    'type': 'flex',
                                                                    'value': 0,
                                                                },
                                                                'elementId': 'cb2dfa91-3076-406d-b0e9-3bfab75c91a1',
                                                            },
                                                            {
                                                                'type': 'text',
                                                                'text': 'List body',
                                                                'textStyle': {
                                                                    'color': '#222121e0',
                                                                    'size': 14,
                                                                    'weight': 'normal',
                                                                },
                                                                'maxTextLines': 5,
                                                                'height': {
                                                                    'type': 'flex',
                                                                    'value': 1,
                                                                },
                                                                'width': {
                                                                    'type': 'flex',
                                                                    'value': 0,
                                                                },
                                                                'elementId': '88bb07e0-8226-4e03-b2a1-d8796a8d558e',
                                                            },
                                                        ],
                                                        'height': {
                                                            'type': 'flex',
                                                            'value': 1,
                                                        },
                                                        'width': {
                                                            'type': 'flex',
                                                            'value': 0,
                                                        },
                                                        'elementId': '169ca327-1784-4ae4-bb1c-52963268a1de',
                                                    },
                                                ],
                                                'height': {
                                                    'type': 'flex',
                                                    'value': 1,
                                                },
                                                'width': {
                                                    'type': 'flex',
                                                    'value': 0,
                                                },
                                                'elementId': '732ae02b-adff-46d2-b011-f94a2d93b4ba',
                                            },
                                            {
                                                'type': 'box',
                                                'layout': 'row',
                                                'viewStyle': {
                                                    'margin': {
                                                        'top': 16,
                                                        'right': 0,
                                                        'bottom': 0,
                                                        'left': 0,
                                                    },
                                                },
                                                'items': [
                                                    {
                                                        'type': 'imageButton',
                                                        'viewStyle': {
                                                            'radius': 100,
                                                            'backgroundColor': '#5a73baff',
                                                        },
                                                        'width': {
                                                            'type': 'fixed',
                                                            'value': 40,
                                                        },
                                                        'height': {
                                                            'type': 'fixed',
                                                            'value': 40,
                                                        },
                                                        'imageUrl': 'https://ddtyj01cn62am.cloudfront.net/notifications/default-notification-channel-cover.png',
                                                        'imageStyle': {
                                                            'contentMode': 'aspectFill',
                                                            'tintColor': '#ffffffff',
                                                        },
                                                        'elementId': '1761210e-beab-4d19-ad12-3c7776ce066d',
                                                    },
                                                    {
                                                        'type': 'box',
                                                        'layout': 'column',
                                                        'viewStyle': {
                                                            'margin': {
                                                                'left': 12,
                                                                'top': 0,
                                                                'right': 0,
                                                                'bottom': 0,
                                                            },
                                                        },
                                                        'items': [
                                                            {
                                                                'type': 'text',
                                                                'text': 'List title',
                                                                'textStyle': {
                                                                    'color': '#222121e0',
                                                                    'size': 16,
                                                                    'weight': 'bold',
                                                                },
                                                                'maxTextLines': 5,
                                                                'height': {
                                                                    'type': 'flex',
                                                                    'value': 1,
                                                                },
                                                                'width': {
                                                                    'type': 'flex',
                                                                    'value': 0,
                                                                },
                                                                'elementId': 'f3e69331-e4d1-44f9-bc1a-c0c8589d625e',
                                                            },
                                                            {
                                                                'type': 'text',
                                                                'text': 'List body',
                                                                'textStyle': {
                                                                    'color': '#222121e0',
                                                                    'size': 14,
                                                                    'weight': 'normal',
                                                                },
                                                                'maxTextLines': 5,
                                                                'height': {
                                                                    'type': 'flex',
                                                                    'value': 1,
                                                                },
                                                                'width': {
                                                                    'type': 'flex',
                                                                    'value': 0,
                                                                },
                                                                'elementId': '065a4733-477d-4a15-a7d0-4559025db3c3',
                                                            },
                                                        ],
                                                        'height': {
                                                            'type': 'flex',
                                                            'value': 1,
                                                        },
                                                        'width': {
                                                            'type': 'flex',
                                                            'value': 0,
                                                        },
                                                        'elementId': '3e20f19a-58c6-40ec-8365-0e6ea12a6acb',
                                                    },
                                                ],
                                                'height': {
                                                    'type': 'flex',
                                                    'value': 1,
                                                },
                                                'width': {
                                                    'type': 'flex',
                                                    'value': 0,
                                                },
                                                'elementId': '2e8938ca-5574-4a58-a17c-9bff156a7456',
                                            },
                                        ],
                                        'height': {
                                            'type': 'flex',
                                            'value': 1,
                                        },
                                        'width': {
                                            'type': 'flex',
                                            'value': 0,
                                        },
                                        'elementId': '9c79282d-928c-418e-8111-78a4e19c1353',
                                    },
                                    {
                                        'type': 'box',
                                        'layout': 'row',
                                        'viewStyle': {
                                            'margin': {
                                                'top': 12,
                                                'right': 0,
                                                'bottom': 0,
                                                'left': 0,
                                            },
                                        },
                                        'items': [
                                            {
                                                'type': 'textButton',
                                                'viewStyle': {
                                                    'backgroundColor': '#5a73baff',
                                                    'padding': {
                                                        'top': 10,
                                                        'bottom': 10,
                                                        'left': 20,
                                                        'right': 20,
                                                    },
                                                    'radius': 6,
                                                },
                                                'text': 'Button 1',
                                                'textStyle': {
                                                    'color': '#ffffffff',
                                                    'size': 14,
                                                    'weight': 'bold',
                                                },
                                                'maxTextLines': 5,
                                                'height': {
                                                    'type': 'flex',
                                                    'value': 1,
                                                },
                                                'width': {
                                                    'type': 'flex',
                                                    'value': 0,
                                                },
                                                'elementId': 'f3885375-bc4e-4117-8575-ec241a68091d',
                                            },
                                            {
                                                'type': 'textButton',
                                                'viewStyle': {
                                                    'backgroundColor': '#5a73baff',
                                                    'padding': {
                                                        'top': 10,
                                                        'bottom': 10,
                                                        'left': 20,
                                                        'right': 20,
                                                    },
                                                    'margin': {
                                                        'left': 8,
                                                        'right': 0,
                                                        'top': 0,
                                                        'bottom': 0,
                                                    },
                                                    'radius': 6,
                                                },
                                                'text': 'Button 2',
                                                'textStyle': {
                                                    'color': '#ffffffff',
                                                    'size': 14,
                                                    'weight': 'bold',
                                                },
                                                'maxTextLines': 5,
                                                'height': {
                                                    'type': 'flex',
                                                    'value': 1,
                                                },
                                                'width': {
                                                    'type': 'flex',
                                                    'value': 0,
                                                },
                                                'elementId': '6f9acedd-e382-4f53-a350-bca2276e9b6b',
                                            },
                                        ],
                                        'height': {
                                            'type': 'flex',
                                            'value': 1,
                                        },
                                        'width': {
                                            'type': 'flex',
                                            'value': 0,
                                        },
                                        'elementId': '37bae277-3300-4c2e-a308-c320d73c5725',
                                    },
                                ],
                                'height': {
                                    'type': 'flex',
                                    'value': 1,
                                },
                                'width': {
                                    'type': 'flex',
                                    'value': 0,
                                },
                                'elementId': '62b096a3-0ee7-4467-a8be-9fa1109b257d',
                            },
                        ],
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'width': {
                            'type': 'flex',
                            'value': 0,
                        },
                        'elementId': 'e2708cb7-b237-4ffb-86fe-3bb11b8400b8',
                    },
                ],
            },
        ],
    },
};
const socar_preset_booking_confirm = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'box',
                'layout': 'column',
                'viewStyle': {
                    'padding': { 'top': 5, 'bottom': 5, 'left': 0, 'right': 10 },
                },
                'items': [
                    {
                        'type': 'box',
                        'layout': 'row',
                        'align': { 'horizontal': 'center', 'vertical': 'center' },
                        'items': [
                            {
                                'type': 'imageButton',
                                'width': { 'type': 'fixed', 'value': 70 },
                                'height': { 'type': 'flex', 'value': 1 },
                                'align': { 'horizontal': 'center', 'vertical': 'center' },
                                'imageUrl': 'https://search.pstatic.net/common?type=f&size=298x140&quality=95&direct=true&ttype=input&src=https%3A%2F%2Fimgauto-phinf.pstatic.net%2F20240116_168%2Fauto_17053701702442qv0L_PNG%2F20240116105600_9xS4XPiV.png',
                                'metaData': { 'pixelWidth': '149', 'pixelHeight': '70' },
                            },
                            {
                                'type': 'box',
                                'layout': 'column',
                                'items': [
                                    {
                                        'type': 'text',
                                        'text': '예약완료',
                                        'width': { 'type': 'flex', 'value': 1 },
                                        'align': { 'horizontal': 'right', 'vertical': 'center' },
                                        'viewStyle': {
                                            'backgroundColor': '#F0FAFF',
                                            'radius': 4,
                                            'padding': { 'top': 2, 'bottom': 1, 'left': 4, 'right': 4 },
                                        },
                                        'textStyle': { 'color': '#3BC7FF', 'weight': 'bold', 'size': 12 },
                                        'maxTextLines': '1',
                                    },
                                    {
                                        'type': 'text',
                                        'text': '[슈퍼딜] 2024 포드 머스탱 컨버터블',
                                        'textStyle': { 'weight': 'bold' },
                                        'viewStyle': {
                                            'margin': { 'top': 2 },
                                        },
                                        'maxTextLines': '1',
                                    },
                                    {
                                        'type': 'text',
                                        'text': '출발: 03.24.(금) 15:00\n도착: 03.27.(월) 11:00',
                                        'textStyle': { 'weight': 'normal' },
                                        'maxTextLines': '2',
                                    },
                                ],
                            },
                            {
                                'type': 'textButton',
                                'text': '선택',
                                'width': { 'type': 'fixed', 'value': 60 },
                                'height': { 'type': 'fixed', 'value': 30 },
                                'viewStyle': {
                                    'radius': 17,
                                    'padding': { 'top': 0, 'bottom': 0, 'left': 0, 'right': 0 },
                                },
                                'textStyle': { 'weight': 'bold' },
                                'maxTextLines': '1',
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
const carousel_case_1 = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'carouselView',
                'viewStyle': {
                    'padding': {
                        'top': 12,
                        'bottom': 12,
                        'left': 12,
                        'right': 12,
                    },
                },
                'carouselStyle': {
                    'spacing': 10,
                },
                'items': [
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'row',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'padding': {
                                            'top': '8',
                                            'bottom': '8',
                                            'left': '12',
                                            'right': '12',
                                        },
                                        'radius': '12',
                                        'backgroundColor': '#ffffffff',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'height': {
                                        'type': 'fixed',
                                        'value': '470',
                                    },
                                    'items': [
                                        {
                                            'type': 'text',
                                            'text': '{content}',
                                            'textStyle': {
                                                'size': '14',
                                                'color': '#ff374553',
                                                'weight': 'normal',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'padding': {
                                            'top': '8',
                                            'bottom': '8',
                                            'left': '12',
                                            'right': '12',
                                        },
                                        'radius': '12',
                                        'backgroundColor': '#ffffffff',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'height': {
                                        'type': 'fixed',
                                        'value': '470',
                                    },
                                    'items': [
                                        {
                                            'type': 'text',
                                            'text': '{content}',
                                            'textStyle': {
                                                'size': '14',
                                                'color': '#ff374553',
                                                'weight': 'normal',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                        },
                                        {
                                            'type': 'textButton',
                                            'viewStyle': {
                                                'backgroundColor': '#fff2f4f6',
                                                'radius': '8',
                                                'margin': {
                                                    'top': '12',
                                                    'bottom': '4',
                                                    'left': '12',
                                                    'right': '12',
                                                },
                                                'padding': {
                                                    'top': '0',
                                                    'bottom': '0',
                                                    'left': '0',
                                                    'right': '0',
                                                },
                                            },
                                            'text': '{button_text_1}',
                                            'textStyle': {
                                                'size': '14',
                                                'color': '#ff374553',
                                                'weight': 'normal',
                                            },
                                            'maxTextLines': '1',
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'fixed',
                                                'value': '36',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'padding': {
                                            'top': '8',
                                            'bottom': '8',
                                            'left': '12',
                                            'right': '12',
                                        },
                                        'radius': '12',
                                        'backgroundColor': '#ffffffff',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'height': {
                                        'type': 'fixed',
                                        'value': '470',
                                    },
                                    'items': [
                                        {
                                            'type': 'text',
                                            'text': '{content}',
                                            'textStyle': {
                                                'size': '14',
                                                'color': '#ff374553',
                                                'weight': 'normal',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                        },
                                        {
                                            'type': 'textButton',
                                            'viewStyle': {
                                                'backgroundColor': '#fff2f4f6',
                                                'radius': '8',
                                                'margin': {
                                                    'top': '12',
                                                    'bottom': '4',
                                                    'left': '12',
                                                    'right': '12',
                                                },
                                                'padding': {
                                                    'top': '0',
                                                    'bottom': '0',
                                                    'left': '0',
                                                    'right': '0',
                                                },
                                            },
                                            'text': '{button_text_1}',
                                            'textStyle': {
                                                'size': '14',
                                                'color': '#ff374553',
                                                'weight': 'normal',
                                            },
                                            'maxTextLines': '1',
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'fixed',
                                                'value': '36',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
};
const carousel_case_2_all_flex = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'carouselView',
                'viewStyle': {
                    'padding': {
                        'top': 12,
                        'bottom': 12,
                        'left': 12,
                        'right': 12,
                    },
                },
                'carouselStyle': {
                    'spacing': 10,
                },
                'items': [
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'center',
                                    },
                                    'viewStyle': {
                                        'backgroundColor': 'transparent',
                                        'padding': {
                                            'top': '0',
                                            'bottom': '0',
                                            'left': '0',
                                            'right': '0',
                                        },
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '50',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'items': [
                                        {
                                            'type': 'imageButton',
                                            'viewStyle': {
                                                'backgroundColor': '{SBCOLOR_q5tul}',
                                                'radius': '20',
                                                'padding': {
                                                    'top': '8',
                                                    'bottom': '8',
                                                    'left': '8',
                                                    'right': '8',
                                                },
                                                'margin': {
                                                    'top': '8',
                                                    'bottom': '8',
                                                    'left': '8',
                                                    'right': '8',
                                                },
                                            },
                                            'imageUrl': 'https://file-us-1.sendbird.com/b9ba681a0bf742dabb2fc251e0b056a9.png',
                                            'imageStyle': {
                                                'contentMode': 'aspectFill',
                                                'tintColor': '{SBCOLOR_ofmbt}',
                                            },
                                            'metaData': {
                                                'pixelWidth': '18',
                                                'pixelHeight': '18',
                                            },
                                            'width': {
                                                'type': 'fixed',
                                                'value': '34',
                                            },
                                            'height': {
                                                'type': 'fixed',
                                                'value': '34',
                                            },
                                        },
                                        {
                                            'type': 'text',
                                            'text': '더 보기',
                                            'textStyle': {
                                                'size': '10',
                                                'color': '{SBCOLOR_sc3q4}',
                                                'weight': 'normal',
                                            },
                                            'maxTextLines': '1',
                                            'width': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'align': {
                                                'horizontal': 'center',
                                                'vertical': 'top',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
};
const carousel_case_2_all_fixed = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'carouselView',
                'viewStyle': {
                    'padding': {
                        'top': 12,
                        'bottom': 12,
                        'left': 12,
                        'right': 12,
                    },
                },
                'carouselStyle': {
                    'spacing': 10,
                },
                'items': [
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '283',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '283',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '283',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '283',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'center',
                                    },
                                    'viewStyle': {
                                        'backgroundColor': 'transparent',
                                        'padding': {
                                            'top': '0',
                                            'bottom': '0',
                                            'left': '0',
                                            'right': '0',
                                        },
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '50',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'items': [
                                        {
                                            'type': 'imageButton',
                                            'viewStyle': {
                                                'backgroundColor': '{SBCOLOR_q5tul}',
                                                'radius': '20',
                                                'padding': {
                                                    'top': '8',
                                                    'bottom': '8',
                                                    'left': '8',
                                                    'right': '8',
                                                },
                                                'margin': {
                                                    'top': '8',
                                                    'bottom': '8',
                                                    'left': '8',
                                                    'right': '8',
                                                },
                                            },
                                            'imageUrl': 'https://file-us-1.sendbird.com/b9ba681a0bf742dabb2fc251e0b056a9.png',
                                            'imageStyle': {
                                                'contentMode': 'aspectFill',
                                                'tintColor': '{SBCOLOR_ofmbt}',
                                            },
                                            'metaData': {
                                                'pixelWidth': '18',
                                                'pixelHeight': '18',
                                            },
                                            'width': {
                                                'type': 'fixed',
                                                'value': '34',
                                            },
                                            'height': {
                                                'type': 'fixed',
                                                'value': '34',
                                            },
                                        },
                                        {
                                            'type': 'text',
                                            'text': '더 보기',
                                            'textStyle': {
                                                'size': '10',
                                                'color': '{SBCOLOR_sc3q4}',
                                                'weight': 'normal',
                                            },
                                            'maxTextLines': '1',
                                            'width': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'align': {
                                                'horizontal': 'center',
                                                'vertical': 'top',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
};
const carousel_case_2_both_flex_and_fixed = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'carouselView',
                'viewStyle': {
                    'padding': {
                        'top': 12,
                        'bottom': 12,
                        'left': 12,
                        'right': 12,
                    },
                },
                'carouselStyle': {
                    'spacing': 10,
                },
                'items': [
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '283',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'left',
                                        'vertical': 'top',
                                    },
                                    'viewStyle': {
                                        'radius': '12',
                                        'backgroundColor': '{SBCOLOR_4pivj}',
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '340',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'row',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'center',
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '20',
                                                            'bottom': '20',
                                                            'left': '16',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'imageUrl': '{image_url.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '40',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{image_url.width}',
                                                        'pixelHeight': '{image_url.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'margin': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '0',
                                                            'right': '16',
                                                        },
                                                        'backgroundColor': '{SBCOLOR_p7200}',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_j80gp}',
                                                                'radius': '4',
                                                                'padding': {
                                                                    'top': '2',
                                                                    'bottom': '2',
                                                                    'left': '4',
                                                                    'right': '4',
                                                                },
                                                            },
                                                            'text': '예약완료',
                                                            'textStyle': {
                                                                'size': '10',
                                                                'color': '{SBCOLOR_89v35}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '4',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{reservation_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_2ahre}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'text',
                                                            'text': '{departure_time}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_7fggh}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'left',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'padding': {
                                                    'top': '4',
                                                    'right': '12',
                                                    'bottom': '12',
                                                    'left': '12',
                                                },
                                            },
                                            'width': {
                                                'type': 'flex',
                                                'value': '0',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP1',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP2',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                                {
                                                    'type': 'textButton',
                                                    'viewStyle': {
                                                        'backgroundColor': '{SBCOLOR_4fx1e}',
                                                        'radius': '8',
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '8',
                                                            'left': '20',
                                                            'right': '20',
                                                        },
                                                        'margin': {
                                                            'top': '4',
                                                            'bottom': '0',
                                                            'left': '0',
                                                            'right': '0',
                                                        },
                                                    },
                                                    'text': '문의사항 TOP3',
                                                    'textStyle': {
                                                        'size': '14',
                                                        'color': '{SBCOLOR_pg796}',
                                                        'weight': 'bold',
                                                    },
                                                    'maxTextLines': '1',
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'center',
                                    },
                                    'viewStyle': {
                                        'backgroundColor': 'transparent',
                                        'padding': {
                                            'top': '0',
                                            'bottom': '0',
                                            'left': '0',
                                            'right': '0',
                                        },
                                    },
                                    'width': {
                                        'type': 'fixed',
                                        'value': '50',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'items': [
                                        {
                                            'type': 'imageButton',
                                            'viewStyle': {
                                                'backgroundColor': '{SBCOLOR_q5tul}',
                                                'radius': '20',
                                                'padding': {
                                                    'top': '8',
                                                    'bottom': '8',
                                                    'left': '8',
                                                    'right': '8',
                                                },
                                                'margin': {
                                                    'top': '8',
                                                    'bottom': '8',
                                                    'left': '8',
                                                    'right': '8',
                                                },
                                            },
                                            'imageUrl': 'https://file-us-1.sendbird.com/b9ba681a0bf742dabb2fc251e0b056a9.png',
                                            'imageStyle': {
                                                'contentMode': 'aspectFill',
                                                'tintColor': '{SBCOLOR_ofmbt}',
                                            },
                                            'metaData': {
                                                'pixelWidth': '18',
                                                'pixelHeight': '18',
                                            },
                                            'width': {
                                                'type': 'fixed',
                                                'value': '34',
                                            },
                                            'height': {
                                                'type': 'fixed',
                                                'value': '34',
                                            },
                                        },
                                        {
                                            'type': 'text',
                                            'text': '더 보기',
                                            'textStyle': {
                                                'size': '10',
                                                'color': '{SBCOLOR_sc3q4}',
                                                'weight': 'normal',
                                            },
                                            'maxTextLines': '1',
                                            'width': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'align': {
                                                'horizontal': 'center',
                                                'vertical': 'center',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
};
const carousel_case_3 = {
    'version': 1,
    'body': {
        'items': [
            {
                'type': 'carouselView',
                'viewStyle': {
                    'padding': {
                        'top': 12,
                        'bottom': 12,
                        'left': 12,
                        'right': 12,
                    },
                },
                'carouselStyle': {
                    'spacing': 10,
                },
                'items': [
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'width': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'center',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'radius': '12',
                                                'borderWidth': '1',
                                                'borderColor': '{SBCOLOR_sq5wz}',
                                                'backgroundColor': '{SBCOLOR_byw2t}',
                                            },
                                            'width': {
                                                'type': 'fixed',
                                                'value': '254',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'imageUrl': '{guide-image.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '143',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{guide-image.width}',
                                                        'pixelHeight': '{guide-image.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '12',
                                                            'left': '12',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_zhxc4}',
                                                                'padding': {
                                                                    'top': '0',
                                                                    'bottom': '8',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{guide_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_imwgs}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'textButton',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_56piy}',
                                                                'radius': '8',
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '0',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{guide_button}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_fz5ow}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                    'viewStyle': {
                                        'backgroundColor': '{SBCOLOR_jvnor}',
                                    },
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'top',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'width': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'center',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'radius': '12',
                                                'borderWidth': '1',
                                                'borderColor': '{SBCOLOR_sq5wz}',
                                                'backgroundColor': '{SBCOLOR_byw2t}',
                                            },
                                            'width': {
                                                'type': 'fixed',
                                                'value': '254',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'imageUrl': '{guide-image.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '143',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{guide-image.width}',
                                                        'pixelHeight': '{guide-image.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '12',
                                                            'left': '12',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_zhxc4}',
                                                                'padding': {
                                                                    'top': '0',
                                                                    'bottom': '8',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{guide_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_imwgs}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'textButton',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_56piy}',
                                                                'radius': '8',
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '0',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{guide_button}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_fz5ow}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                    'viewStyle': {
                                        'backgroundColor': '{SBCOLOR_jvnor}',
                                    },
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'top',
                                    },
                                },
                            ],
                        },
                    },
                    {
                        'version': 1,
                        'body': {
                            'items': [
                                {
                                    'type': 'box',
                                    'layout': 'column',
                                    'width': {
                                        'type': 'flex',
                                        'value': '0',
                                    },
                                    'height': {
                                        'type': 'flex',
                                        'value': '1',
                                    },
                                    'items': [
                                        {
                                            'type': 'box',
                                            'layout': 'column',
                                            'align': {
                                                'horizontal': 'center',
                                                'vertical': 'top',
                                            },
                                            'viewStyle': {
                                                'radius': '12',
                                                'borderWidth': '1',
                                                'borderColor': '{SBCOLOR_sq5wz}',
                                                'backgroundColor': '{SBCOLOR_byw2t}',
                                            },
                                            'width': {
                                                'type': 'fixed',
                                                'value': '254',
                                            },
                                            'height': {
                                                'type': 'flex',
                                                'value': '1',
                                            },
                                            'items': [
                                                {
                                                    'type': 'image',
                                                    'imageUrl': '{guide-image.url}',
                                                    'imageStyle': {
                                                        'contentMode': 'aspectFill',
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'fixed',
                                                        'value': '143',
                                                    },
                                                    'metaData': {
                                                        'pixelWidth': '{guide-image.width}',
                                                        'pixelHeight': '{guide-image.height}',
                                                    },
                                                },
                                                {
                                                    'type': 'box',
                                                    'layout': 'column',
                                                    'align': {
                                                        'horizontal': 'left',
                                                        'vertical': 'top',
                                                    },
                                                    'viewStyle': {
                                                        'padding': {
                                                            'top': '8',
                                                            'bottom': '12',
                                                            'left': '12',
                                                            'right': '12',
                                                        },
                                                    },
                                                    'width': {
                                                        'type': 'flex',
                                                        'value': '0',
                                                    },
                                                    'height': {
                                                        'type': 'flex',
                                                        'value': '1',
                                                    },
                                                    'items': [
                                                        {
                                                            'type': 'text',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_zhxc4}',
                                                                'padding': {
                                                                    'top': '0',
                                                                    'bottom': '8',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{guide_title}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_imwgs}',
                                                                'weight': 'normal',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                            'align': {
                                                                'horizontal': 'left',
                                                                'vertical': 'top',
                                                            },
                                                        },
                                                        {
                                                            'type': 'textButton',
                                                            'viewStyle': {
                                                                'backgroundColor': '{SBCOLOR_56piy}',
                                                                'radius': '8',
                                                                'margin': {
                                                                    'top': '4',
                                                                    'bottom': '0',
                                                                    'left': '0',
                                                                    'right': '0',
                                                                },
                                                            },
                                                            'text': '{guide_button}',
                                                            'textStyle': {
                                                                'size': '14',
                                                                'color': '{SBCOLOR_fz5ow}',
                                                                'weight': 'bold',
                                                            },
                                                            'maxTextLines': '1',
                                                            'width': {
                                                                'type': 'flex',
                                                                'value': '0',
                                                            },
                                                            'height': {
                                                                'type': 'flex',
                                                                'value': '1',
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                    'viewStyle': {
                                        'backgroundColor': '{SBCOLOR_jvnor}',
                                    },
                                    'align': {
                                        'horizontal': 'center',
                                        'vertical': 'top',
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
};
export const samples_for_size_spec = [
    horizontal_wrap_wrap,
    horizontal_wrap_wrap_wrap,
    horizontal_fill_wrap,
    horizontal_fill_fill_wrap,
    horizontal_fill_wrap_fill_wrap,
    horizontal_fill_wrap_fill_wrap_long,
    horizontal_fill_wrap_fill_wrap_longer,
    horizontal_fill_wrap_fill_wrap_super_long,
    horizontal_fill_wrap_wrap_long_content,
    horizontal_fill_wrap_remain_padding,
    horizontal_fill_wrap_no_padding,
    vertical_fill_wrap_wrap_remain_padding,
    vertical_fill_wrap_wrap_no_padding,
];
const column_box_horz_margin_and_fill_parent_children = {
    'version': 1,
    'body': {
        'items': [
            {
                'elementId': 'root',
                'type': 'box',
                'layout': 'column',
                'width': {
                    'type': 'flex',
                    'value': FlexSizeSpecValue.FillParent,
                },
                'height': {
                    'type': 'flex',
                    'value': FlexSizeSpecValue.WrapContent,
                },
                'items': [
                    {
                        'type': 'text',
                        'viewStyle': {
                            'backgroundColor': '#a0c0ffff',
                            'margin': {
                                'top': 16,
                                'bottom': 16,
                                'left': 16,
                                'right': 16,
                            },
                            'padding': {
                                'top': 16,
                                'bottom': 16,
                                'left': 16,
                                'right': 16,
                            },
                        },
                        'text': 'Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap Wrap ',
                        'textStyle': {
                            'size': 14,
                            'color': '#222121e0',
                            'weight': 'normal',
                        },
                        'maxTextLines': 5,
                        'width': {
                            'type': 'flex',
                            'value': FlexSizeSpecValue.FillParent,
                        },
                        'height': {
                            'type': 'flex',
                            'value': 1,
                        },
                        'align': {
                            'horizontal': 'left',
                            'vertical': 'top',
                        },
                        'elementId': 'c0e15878-4984-408d-abaa-4b495c2e3872',
                    },
                    {
                        'type': 'imageButton',
                        'viewStyle': {
                            margin: {
                                left: 24,
                                right: 12,
                            },
                        },
                        'width': { 'type': 'flex', 'value': FlexSizeSpecValue.FillParent },
                        'height': { 'type': 'fixed', 'value': 250 },
                        'imageUrl': 'https://cdn.pixabay.com/photo/2022/10/12/10/45/bird-7516219_1280.jpg',
                        'imageStyle': { 'contentMode': 'aspectFill' },
                        'metaData': { 'pixelWidth': '1080', 'pixelHeight': '2640' },
                        'action': { 'data': 'www.naver.com' },
                    },
                ],
            },
        ],
    },
};
export const samples_for_margin_issue = [column_box_horz_margin_and_fill_parent_children];
export const samples = [
    sample_1,
    sample_2,
    sample_3,
    sample_4,
    sample_5,
    sample_6,
    sample_for_inset_border,
    sample_clipped_text__large_padding,
    sample_for_priority_by_size_spec,
    dashboard_preset_list,
    socar_preset_booking_confirm,
    // Example reference: https://sendbird.atlassian.net/wiki/spaces/UK/pages/2265484095/UIKit+message+template+syntax+extension+proposal#Carousel-test-syntax
    carousel_case_1,
    carousel_case_2_all_flex,
    carousel_case_2_all_fixed,
    carousel_case_2_both_flex_and_fixed,
    carousel_case_3,
];
